import styled from 'styled-components';

export const StyledRowWrapper = styled.div`
  padding-top: 2.4rem;
  padding-bottom: 2.4rem;
  display: flex;
  align-items: flex-start;
  gap: 2.4rem;
  flex-wrap: wrap;
`;

export const StyledRowTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-basis: 100%;
  }
`;

export const StyledRowHeading = styled.h2`
  font-size: 1.8rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin: 0;
`;

export const StyledRowDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledFormRowInputContainer = styled.div`
  flex: 1;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-basis: 100%;
  }
`;

export const StyledLine = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border.light};
`;
